import { useEffect, useRef, useState } from "react";
import ModalBasicLayout from "../Modal/ModalBasicLayout";
import Loader from "../Loaders/Loader";
import { SimpleAlert } from "../Alerts/Alerts";
import { useTranslationApp } from "../../lib/i18next";
import { useDispatchApp } from "../../lib/redux";
import { startGetLeadFormByID } from "../../actions/adsCampaigns";
import {
  LOADING_INFORMATION,
  MODAL_VIEW_LEAD_FORM_LOAD_ERROR,
  MODAL_VIEW_LEAD_FORM_TITLE,
} from "../../i18n/keysTranslations";
import { META } from "../../utils/constants";
import ModalCreateInstantForm from "./ModalCreateInstantForm";

const ModalViewInstantForm = ({
  modalOpen = false,
  onCloseModal = () => {},
  onCallbackSave = () => {},
  instantForm,
  integrationID,
  pageID,
}) => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const [viewValues, setViewValues] = useState(null);
  const onCloseModalRef = useRef(onCloseModal);
  onCloseModalRef.current = onCloseModal;

  useEffect(() => {
    if (!modalOpen) return undefined;

    let isActive = true;

    const onLoadInstantForm = async () => {
      const response = await dispatch(
        startGetLeadFormByID({
          platform: META,
          integrationID,
          pageID,
          leadFormID: instantForm?.id,
          shouldContinue: () => isActive,
        })
      );

      if (!isActive || response?.code === "aborted") return;

      if (!response?.ok || !response?.data?.duplicateValues) {
        SimpleAlert({
          icon: "error",
          text: t(MODAL_VIEW_LEAD_FORM_LOAD_ERROR),
        });
        onCloseModalRef.current();
        return;
      }

      setViewValues(response.data.duplicateValues);
    };

    onLoadInstantForm();

    return () => {
      isActive = false;
    };
  }, [dispatch, instantForm?.id, integrationID, modalOpen, pageID, t]);

  if (viewValues) {
    return (
      <ModalCreateInstantForm
        key={`view-${instantForm?.id}`}
        modalOpen={modalOpen}
        onCloseModal={onCloseModal}
        integrationID={integrationID}
        pageID={pageID}
        initialValues={viewValues}
        readOnly
        onCallbackSave={onCallbackSave}
      />
    );
  }

  // The read-only form modal replaces this loader and owns the history entry.
  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth
      scroll="paper"
      maxWidth="sm"
      title={t(MODAL_VIEW_LEAD_FORM_TITLE)}
      enableHistoryManagement={false}
    >
      <Loader hasMessage message={t(LOADING_INFORMATION)} />
    </ModalBasicLayout>
  );
};

export default ModalViewInstantForm;
